/**
 * Calendar page (/calendar) — parents and coaches.
 *
 * Renders the unified calendar feed (`GET /api/v1/calendar/`), which returns
 * class SESSIONS, events and cancellations already scoped to the caller's
 * role by the server.
 *
 * This page previously fetched *Events only*, for a single arbitrary class
 * picked from the first enrollment — so class sessions never appeared at all,
 * a parent with two children saw one child's class, and with no class it fell
 * back to org-wide upcoming events that had nothing to do with the family.
 * Combined with the calendar component's hard-coded demo events, a freshly
 * registered child produced a calendar full of sessions that did not exist.
 *
 * `SharedCalendar` is the same component the dashboards use, so all four
 * surfaces now agree with each other and with the backend.
 */

import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SharedCalendar from "../components/calendar/SharedCalendar";

const Calender = () => {
  return (
    <div className="min-h-screen max-sm:h-fit bg-page-gradient max-sm:pb-20">
      <Header />
      <main className="px-6 py-8 max-sm:py-2 max-sm:px-3 lg:bg-card_bg lg:mt-10 lg:m-5 lg:rounded-[30px] shadow-lg">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-fluid-2xl px-2 text-[#173151] font-kollektif font-normal leading-[1.002] tracking-[-0.02em]">
            Calendar
          </h1>
        </div>

        <SharedCalendar height={640} />
      </main>
      <Footer isFixed={false} />
    </div>
  );
};

export default Calender;
